import { render, staticRenderFns } from "./ResetUserCustodian.vue?vue&type=template&id=0e8dcd8e"
import script from "./ResetUserCustodian.vue?vue&type=script&lang=ts"
export * from "./ResetUserCustodian.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports